import { useFormik } from 'formik';
import * as Yup from 'yup';

export function useNegociationValidation(onSubmit) {
  const initialValues = {
    contactMethod: '',
  };

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      contactMethod: Yup.string().required(
        'El campo método de contacto es requerido',
      ),
    }),
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit,
  });

  return formik;
}
